module.exports = __webpack_public_path__ + "img/gg.964dbd35.svg";